import { useQuery } from '@tanstack/react-query';
import { dailyApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** @registry One daily report with its questions, progress items and attachments. */
export function useDaily(dailyId: string | null | undefined) {
  return useQuery({
    queryKey: queryKeys.dailys.detail(dailyId ?? ''),
    queryFn: ({ signal }) =>
      dailyApiClient.get(dailyId!, toCancelToken(signal)),
    enabled: !!dailyId,
    staleTime: 0,
    meta: { errorContext: 'daily detail' },
  });
}
